export const sideNavElementSelectors = {
  name: {
    root: 'side-nav',
    collapseToggle: 'side-nav-collapse-toggle'
  }
};

export const sideNavSeparatorBeforeIds = ['rm-backup-parent', 'reporting', 'downloads'];

export const sideNavTopLevelOrder = [
  'overview',
  'rm',
  'rm-backup-parent',
  'rm-rmm-parent',
  'appsMenu',
  'tickets',
  'reporting',
  'organization',
  'settings',
  'downloads'
];

export const sideNavFlyoutDistance = 7;

export const sideNavChildOrder: Record<string, string[]> = {
  organization: ['administrators', 'companies', 'licenses', 'users', 'purchase-history', 'audit-log']
};
